module.exports = __webpack_public_path__ + "static/media/primes.ded2944c.jpg";